import React, { useState } from 'react';
import { IoMdClose } from 'react-icons/io';

import TriggerModal from './TriggerModal';
import SelectedTriggerItem from './../form/SelectedTriggerItem';
import DataSourceModal from './DataSourceModal';
import { getFileIcon } from '../chat/AttachmentIcon';

const IntegrationModal = ({
  integrationData,
  selectedIntegrationAppOptions,
  setSelectedIntegrationAppOptions,
  selectedDataSourceFiles,
  setSelectedDataSourceFiles,
  onClose,
}) => {
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false);
  const [editOption, setEditOption] = useState(null);
  const [isDataSourceSelectionModalOpen, setIsDataSourceSelectionModalOpen] =
    useState(false);
  // const [selectedDataSourceFiles, setSelectedDataSourceFiles] = useState([]);

  const handleIntegrationEditOption = (option) => {
    setEditOption(option);
    setIsIntegrationModalOpen(true);
  };
  const handleDataSourceModalClose = () => {
    setIsDataSourceSelectionModalOpen(false);
  };

  const handleDeleteIntegrationOption = (optionId) => {
    setSelectedIntegrationAppOptions((prev) =>
      prev.filter((item) => item.id !== optionId),
    );
  };

  return (
    <div className="fixed left-0 top-0 z-[100] flex h-screen w-screen items-center justify-center bg-black bg-opacity-20 backdrop-blur-sm transition-all duration-200 ease-in-out">
      <div className="bg-1 h-[90%] w-[90%] max-w-3xl overflow-auto rounded-lg">
        <div className="flex justify-between border-b border-zinc-800 px-3 py-5">
          <h1 className="text-xl font-bold">
            App Integrations and Data Sources
          </h1>
          <button
            onClick={() => onClose()}
            className="bg-1 rounded-lg p-1.5 transition-all duration-200"
          >
            <IoMdClose className="text-white" />
          </button>
        </div>
        <div className="flex flex-col gap-8 p-6">
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between rounded-lg bg-zinc-950 px-3 py-2">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">App integrations</h1>
                <p className="text-p-text text-sm">
                  Add applications included in the workflow
                </p>
              </div>
              <button
                onClick={() => setIsIntegrationModalOpen(true)}
                className="rounded-lg border border-zinc-200 px-2 py-1 text-sm transition-all duration-200"
              >
                ADD
              </button>
            </div>
            {selectedIntegrationAppOptions.map((item) => (
              <SelectedTriggerItem
                key={item.id} // Ensure `id` is unique
                item={item}
                handleEditOption={() => handleIntegrationEditOption(item)}
                handleDeleteOption={() =>
                  handleDeleteIntegrationOption(item.id)
                }
              />
            ))}
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between gap-3 rounded-lg bg-zinc-950 px-3 py-2">
              <div className="flex flex-col gap-1 ">
                <h1 className="text-base font-semibold">Data sources</h1>
                <p className="text-sm">
                  Add data sources required in the workflow
                </p>
              </div>
              <button
                onClick={() => setIsDataSourceSelectionModalOpen(true)}
                className="rounded-lg border border-zinc-200 px-2 py-1 text-sm transition-all duration-200"
              >
                ADD
              </button>
            </div>
            {
              <ul className="flex flex-wrap gap-2">
                {selectedDataSourceFiles.length > 0 &&
                  selectedDataSourceFiles.map((file, idx) => (
                    <li
                      key={idx}
                      className="text-s-text rounded-full bg-zinc-100 px-3 py-1.5 text-sm text-zinc-800"
                    >
                      <div className="flex max-w-[70%] items-center gap-2">
                        {/* <FaFile className="text-white" /> */}
                        {getFileIcon(file.original_filename)}
                        <span
                          className="cursor-pointer truncate text-sm transition-all hover:max-w-none hover:overflow-visible hover:whitespace-normal"
                          title={`${file.original_filename}\nUploaded at: ${file.timestamp}`}
                        >
                          {file.original_filename}
                        </span>
                      </div>
                    </li>
                  ))}
              </ul>
            }
          </div>
        </div>
      </div>

      {isIntegrationModalOpen && (
        <TriggerModal
          title="Add integration"
          desc="Select the app you’d like to add as integration."
          isOpen={isIntegrationModalOpen}
          onClose={() => {
            setIsIntegrationModalOpen(false);
            setEditOption(null);
          }}
          appsData={integrationData}
          selectedOptions={selectedIntegrationAppOptions}
          setSelectedOptions={setSelectedIntegrationAppOptions}
          editOption={editOption}
        />
      )}
      {isDataSourceSelectionModalOpen && (
        <DataSourceModal
          closeModal={handleDataSourceModalClose}
          setSelectedDataSourceFiles={setSelectedDataSourceFiles}
          selectedDataSourceFiles={selectedDataSourceFiles}
        />
      )}
    </div>
  );
};

export default IntegrationModal;
